import React, { useEffect, useState } from "react";
import { Spinner, Button, Modal, Badge } from "react-bootstrap";
import TaskService from "../../services/task.service";
import chatService from "../../services/chat.service";
import Default from "../../components/layouts/default";
import { useNavigate } from "react-router-dom";
import Pagination from "../../components/common/Pagination";
import AnimeSkeleton from "../../components/common/Skeleton";

const Tasks = () => {
  const [taskList, setTaskList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [confirmModal, setConfirmModal] = useState({ show: false, task: null });
  const [page, setPage] = useState(1);
  const [limit] = useState(25);
  const [totalPages, setTotalPages] = useState(1);
  const [currentSet, setCurrentSet] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [showPendingOnly, setShowPendingOnly] = useState(false);
  const [sortBy, setSortBy] = useState('');
  const [sortOrder, setSortOrder] = useState('asc');
  const navigate = useNavigate();

  const fetchTasks = async (currentPage = 1) => {
    try {
      setLoading(true);

      const status = showPendingOnly ? 'pending' : '';
      const res = await TaskService.getTaskList(currentPage, limit, searchTerm, status, sortBy, sortOrder);

      setTaskList(res.tasks);
      setPage(currentPage);
      setTotalPages(res.totalPages || 1);
    } catch (err) {
      console.error("Failed to load tasks:", err);
    } finally {
      setLoading(false);
    }
  };



  const confirmCompleteTask = async () => {
    const task = confirmModal.task;
    try {
await TaskService.updateTask(task.thread_id, {
  taskIndex: task.taskIndex,
  taskDone: true,
});
      fetchTasks();
    } catch (err) {
      console.error("Error updating task:", err);
    } finally {
      setConfirmModal({ show: false, task: null });
    }
  };


  useEffect(() => {
    fetchTasks(page);
  }, [page, searchTerm, showPendingOnly, sortBy, sortOrder]);


  return (
    <Default pageTitle="Tasks">
      <div className="Tasks">
        <div className=" mx-0">
          <div className="card card-body px-0">
            <div className="d-flex flex-lg-row flex-column justify-content-between align-items-center">
              <div className="documents__toolbar d-flex justify-content-between mb-3 ps-3 align-items-center">
                <div className="mx-2 me-4 d-flex align-items-center gap-2">
                  <input
                    type="search"
                    placeholder="Search"
                    value={searchInput}
                    onChange={(e) => {
                      if (e.target.value === "") {
                        setSearchTerm("");
                        setPage(1);
                      }
                      setSearchInput(e.target.value);
                    }}
                    style={{ boxShadow: "none" }}
                    className="form-control form-control-sm"
                  />
                  <button
                    className="btn btn-sm btn-primary"
                    onClick={() => {
                      setSearchTerm(searchInput);
                      setPage(1);
                    }}
                  >
                    Search
                  </button>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="showPendingOnly"
                    checked={showPendingOnly}
                    onChange={(e) => {
                      setShowPendingOnly(e.target.checked);
                      setPage(1);
                    }}
                  />
                  <label className="form-check-label" htmlFor="showPendingOnly">
                    Show Pending
                  </label>
                </div>
              </div>
            </div>

            <div className="table-responsive">
              <table className="table table-striped rounded-3 overflow-hidden">
                <thead style={{ backgroundColor: "#F5F6FA" }}>
                  <tr>
                    <th scope="col" width="30%" style={{ cursor: 'pointer' }}
                      onClick={() => {
                        setSortOrder(sortBy === 'title' ? (sortOrder === 'asc' ? 'desc' : 'asc') : 'asc');
                        setSortBy('title');
                        setPage(1);
                      }}
                    >
                      Task Details {sortBy === 'title' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
                    </th>
                    <th scope="col">Company Name</th>
                    <th scope="col" style={{ cursor: 'pointer' }}
                      onClick={() => {
                        setSortOrder(sortBy === 'status' ? (sortOrder === 'asc' ? 'desc' : 'asc') : 'asc');
                        setSortBy('status');
                        setPage(1);
                      }}
                    >
                      Status {sortBy === 'status' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
                    </th>
                    <th scope="col" style={{ cursor: 'pointer' }}
                      onClick={() => {
                        setSortOrder(sortBy === 'date' ? (sortOrder === 'asc' ? 'desc' : 'asc') : 'asc');
                        setSortBy('date');
                        setPage(1);
                      }}
                    >
                      Completed Date {sortBy === 'date' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
                    </th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>

                <tbody>
                  {loading ? (
                    <AnimeSkeleton rows={5} />
                  ) : taskList.length === 0 ? (
                    <tr>
                      <td colSpan="4" className="text-center text-muted p-3">
                        No tasks found.
                      </td>
                    </tr>
                  ) : (
                    taskList.map((task, index) => (
                      <tr key={index}>
                        <td className="text-black fw-medium text-start">
                          <span className="me-4">{index + 1}.</span>
                          {task.taskDetails}
                        </td>
                        <td className="text-black text-start">
                          {task.client_name || "-"}
                        </td>
                        <td className="text-start">
                          <Badge
                            pill
                            bg={task.taskDone ? "success" : "danger"}
                            className="fw-semibold"
                          >
                            {task.taskDone ? "Completed" : "Pending"}
                          </Badge>
                        </td>
                        <td className="text-black text-start">
                          {task.formattedDate}
                        </td>
                        <td className="text-start">
                          <div className="d-flex gap-3">
                            {!task.taskDone && (
                              <Button
                                variant="link"
                                className="p-0 fw-medium"
                                onClick={() => setConfirmModal({ show: true, task })}
                              >
                                Mark as Complete
                              </Button>
                            )}
                            <Button
                              variant="link"
                              className="p-0 fw-medium text-secondary"
                              onClick={() =>
                                navigate(`/chats?threadId=${task.thread_id}`, {
                                  state: { taskThreadId: task.thread_id },
                                })
                              }
                            >
                              Go to Chats
                            </Button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {taskList.length > 0 && (
              <div className="d-flex justify-content-end mt-3 pe-4">
                <Pagination
                  currentPage={page}
                  TotalPage={totalPages}
                  currentSet={currentSet}
                  setCurrentSet={setCurrentSet}
                  setcurrentPage={(newPage) => setPage(newPage)}
                />
              </div>
            )}

            <Modal
              show={confirmModal.show}
              onHide={() => setConfirmModal({ show: false, task: null })}
            >
              <Modal.Header closeButton>
                <Modal.Title>Confirm Completion</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                Are you sure you want to mark this task as completed?
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => setConfirmModal({ show: false, task: null })}
                >
                  Cancel
                </Button>
                <Button
                  variant="success"
                  onClick={confirmCompleteTask}
                >
                  Yes, Mark Done
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        </div>
      </div>
    </Default>
  );
};

export default Tasks;
